var map = {
	"./20ltrcap2.png": 4161,
	"./28mmflipCap.png": 3048,
	"./30mmflipCap.png": 3905,
	"./aimbg.png": 5581,
	"./aimicon1.png": 694,
	"./aimicon2.png": 4461,
	"./aimicon3.png": 6980,
	"./aimicon4.png": 8971,
	"./backSlash.png": 9847,
	"./bottleCap.png": 1171,
	"./brochure.pdf": 4675,
	"./cipet-certificate.jpg": 7350,
	"./companyPhoto.png": 6456,
	"./contact.png": 5791,
	"./contact2.png": 9149,
	"./contactuseffect.png": 472,
	"./cosidiciTrophy.jpg": 8750,
	"./customers/Blu-Industries_Logo.png": 1165,
	"./customers/avs-logo.png": 7605,
	"./customers/avt.png": 6298,
	"./customers/duropet.png": 4610,
	"./customers/klf.png": 6672,
	"./customers/kpnamboodiris.png": 6627,
	"./customers/star_logo.png": 795,
	"./customers/thaikatu.png": 3926,
	"./deskInfo.png": 9152,
	"./downArrow.svg": 8462,
	"./factory.png": 5633,
	"./machineBig.png": 4640,
	"./machineBigbw.png": 2477,
	"./machineSmall.png": 9255,
	"./productBGeffect.webp": 2054,
	"./products/DCS_2236.webp": 8272,
	"./products/DSC_1956.webp": 2612,
	"./products/DSC_1965.webp": 6506,
	"./products/DSC_1965_prev_ui.webp": 9341,
	"./products/DSC_1969.webp": 206,
	"./products/DSC_1973.webp": 5329,
	"./products/DSC_1980.webp": 1795,
	"./products/DSC_1984.webp": 3359,
	"./products/DSC_1994.webp": 8258,
	"./products/DSC_1995.webp": 2973,
	"./products/DSC_2000.webp": 2667,
	"./products/DSC_2003.webp": 3146,
	"./products/DSC_2004.webp": 9911,
	"./products/DSC_2009.webp": 9856,
	"./products/DSC_2029.webp": 6666,
	"./products/DSC_2030.webp": 4384,
	"./products/DSC_2041.webp": 1468,
	"./products/DSC_2042.webp": 2137,
	"./products/DSC_2043.webp": 9390,
	"./products/DSC_2044.jpg": 5823,
	"./products/DSC_2045.jpg": 9442,
	"./products/DSC_2046.webp": 3645,
	"./products/DSC_2049.webp": 1559,
	"./products/DSC_2068.webp": 3609,
	"./products/DSC_2070.webp": 9940,
	"./products/DSC_2074.webp": 1736,
	"./products/DSC_2075.webp": 4555,
	"./products/DSC_2094.webp": 6930,
	"./products/DSC_2095.webp": 6845,
	"./products/DSC_2103.webp": 7357,
	"./products/DSC_2106.webp": 7278,
	"./products/DSC_2109.webp": 2267,
	"./products/DSC_2117.webp": 8284,
	"./products/DSC_2121.webp": 9009,
	"./products/DSC_2123.webp": 3303,
	"./products/DSC_2124.webp": 2106,
	"./products/DSC_2125.webp": 6277,
	"./products/DSC_2126.webp": 6104,
	"./products/DSC_2127.jpg": 331,
	"./products/DSC_2128.webp": 5518,
	"./products/DSC_2129.jpg": 9501,
	"./products/DSC_2131(1).webp": 8578,
	"./products/DSC_2131.webp": 9368,
	"./products/DSC_2132.jpg": 597,
	"./products/DSC_2133.jpg": 6632,
	"./products/DSC_2134.webp": 4151,
	"./products/DSC_2135.webp": 116,
	"./products/DSC_2136.jpg": 2857,
	"./products/DSC_2137.jpg": 5068,
	"./products/DSC_2138.jpg": 6527,
	"./products/DSC_2139.webp": 9200,
	"./products/DSC_2140.webp": 2004,
	"./products/DSC_2141.webp": 6039,
	"./products/DSC_2142.jpg": 5404,
	"./products/DSC_2144.webp": 1256,
	"./products/DSC_2148.webp": 4956,
	"./products/DSC_2151.webp": 4838,
	"./products/DSC_2153.webp": 2852,
	"./products/DSC_2177.webp": 7682,
	"./products/DSC_2178.webp": 8311,
	"./products/DSC_2183.webp": 7845,
	"./products/DSC_2184.webp": 7636,
	"./products/DSC_2192.webp": 6299,
	"./products/DSC_2193.webp": 8360,
	"./products/DSC_2195.webp": 7174,
	"./products/DSC_2199.webp": 5234,
	"./products/DSC_2202.webp": 6411,
	"./products/DSC_2204.webp": 3793,
	"./products/DSC_2206.webp": 5684,
	"./products/DSC_2207.webp": 9268,
	"./products/DSC_2208.webp": 1437,
	"./products/DSC_2211.webp": 3627,
	"./products/DSC_2215.webp": 2455,
	"./products/DSC_2218.webp": 4192,
	"./products/DSC_2219.webp": 9955,
	"./products/DSC_2223.webp": 1906,
	"./products/DSC_2227.webp": 7518,
	"./products/DSC_2228.webp": 7627,
	"./products/DSC_2230.webp": 8590,
	"./products/DSC_2234.webp": 4626,
	"./products/DSC_2235.webp": 9565,
	"./products/DSC_2236.webp": 1248,
	"./products/DSC_2239.webp": 1313,
	"./products/DSC_2240.webp": 9705,
	"./products/DSC_2242.webp": 8271,
	"./products/DSC_2249.webp": 8774,
	"./products/DSC_2256.webp": 3794,
	"./products/DSC_2258.webp": 2884,
	"./products/DSC_2259.webp": 3943,
	"./products/DSC_2261.webp": 7300,
	"./products/DSC_2262.webp": 7937,
	"./products/DSC_2263.webp": 3094,
	"./products/DSC_2264.webp": 859,
	"./products/DSC_2265.webp": 952,
	"./products/DSC_2266.webp": 3381,
	"./products/DSC_2269.webp": 1084,
	"./products/DSC_2272.webp": 8608,
	"./products/DSC_2274.webp": 78,
	"./products/DSC_2278.webp": 1898,
	"./products/DSC_2284.webp": 1209,
	"./products/DSC_2288.webp": 3621,
	"./products/DSC_2295.webp": 7311,
	"./products/DSC_2296.webp": 8014,
	"./products/DSC_2299.webp": 9707,
	"./products/DSC_2311.webp": 1204,
	"./products/DSC_2317.webp": 1498,
	"./products/DSC_2318.webp": 5951,
	"./products/DSC_2323.webp": 1561,
	"./products/DSC_2332.webp": 2399,
	"./products/DSC_2333.webp": 7516,
	"./products/DSC_2334.webp": 6842,
	"./products/DSC_2335.webp": 9746,
	"./products/DSC_2339.webp": 9222,
	"./products/DSC_2340.webp": 5630,
	"./products/DSC_2343.webp": 8079,
	"./products/DSC_2345.webp": 2061,
	"./products/DSC_2347.webp": 19,
	"./products/DSC_2348.webp": 8614,
	"./products/DSC_2352.webp": 9213,
	"./products/DSC_2357.webp": 8238,
	"./products/DSC_2360.webp": 6152,
	"./products/DSC_2361.webp": 9883,
	"./products/DSC_2362.webp": 1642,
	"./products/DSC_2363.webp": 2261,
	"./products/DSC_2367.webp": 8065,
	"./products/DSC_2373.webp": 5384,
	"./products/DSC_2381.webp": 7461,
	"./products/DSC_2388.webp": 4034,
	"./products/DSC_2393.webp": 3070,
	"./products/DSC_2394.webp": 2803,
	"./products/DSC_2428.webp": 446,
	"./products/DSC_2429.webp": 790,
	"./products/DSC_2430.png": 6818,
	"./products/DSC_2430.webp": 908,
	"./products/DSC_2431.png": 7323,
	"./products/DSC_2432.png": 3504,
	"./products/DSC_2434.png": 4953,
	"./products/DSC_2435.png": 4908,
	"./products/DSC_2436.png": 7412,
	"./products/DSC_2436.webp": 7106,
	"./products/V-CP-BL0931.jpg": 8682,
	"./products/V-CP-BL1329.jpg": 4972,
	"./products/V-CP-BL1528.jpg": 6871,
	"./products/V-CP-BL1610.jpg": 3541,
	"./products/V-CP-BL1726.jpg": 9963,
	"./products/V-CP-BL4310.jpg": 9443,
	"./products/V-JC-BL0032.jpg": 8964,
	"./products/V-JC-BL1400.jpg": 5632,
	"./products/V-JC-BL1600.jpg": 8466,
	"./products/V-JC-BL2600.jpg": 7827,
	"./products/V-JC-BL2620.jpg": 2997,
	"./products/V-JC-BL2700.jpg": 3854,
	"./products/V-JC-BL2702.jpg": 1212,
	"./products/V-JC-BL2704.jpg": 9514,
	"./products/V-JC-BL2720.jpg": 4292,
	"./products/V-JC-BL2800.jpg": 9285,
	"./products/V-JC-BL2802.jpg": 951,
	"./products/V-JC-BL2900.jpg": 480,
	"./products/V-JC-BL2902.jpg": 4418,
	"./products/V-JC-BL2904.jpg": 8068,
	"./products/V-JC-BL3000.jpg": 6737,
	"./products/V-JC-BL3020.jpg": 6676,
	"./products/V-JC-BL3100.jpg": 2275,
	"./products/V-PI-TR0900.jpg": 4374,
	"./products/V-PI-TR0927.jpg": 8247,
	"./products/V-PI-TR1327.jpg": 4862,
	"./products/default.webp": 27,
	"./slider/20240610_065438.webp": 4403,
	"./slider/DSC_2421.webp": 1,
	"./slider/DSC_2425.webp": 2533,
	"./slider/cap1.webp": 4438,
	"./slider/cap2.webp": 55,
	"./slider/factory.webp": 7189,
	"./slider/factory2.webp": 5893,
	"./slider/factory3.webp": 4794,
	"./slider/factory4.webp": 6797,
	"./slider/factory5.jpg": 2482,
	"./slider/gate.webp": 3538,
	"./slider/gate2.jpg": 8060,
	"./slider/machineBig.webp": 3324,
	"./slider/smallMachine.webp": 6433,
	"./smiley.svg": 7418,
	"./statsBg.jpeg": 1568,
	"./trophywithBG.png": 6536,
	"./trophywithoutBG.png": 4740,
	"./viewDetails.png": 7344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;